<template>
    <div>
      <vue-good-table
        mode="remote"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        :totalRows="table.total_records"
        :isLoading.sync="table.isLoading"
        :pagination-options="{
          enabled: true,
          dropdownAllowAll: false,
          perPageDropdown: [10, 25, 50, 100],
        }"
        :columns="table.columns"
        :rows="table.rows"
      >
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'token_limit'">
                Per Chat : {{ props.row.max_token_chat }}
                <br>
                Per Number / Day : {{ props.row.daily_max_token_number }}
                <br>
                Per Day : {{ props.row.daily_max_token_global }}
            </span>
            <span v-else-if="props.column.field == 'device'">
                {{ getDeviceNameByID(props.row.device_id) }}
            </span>
            <span v-else-if="props.column.field == 'quota'">
              {{ formatResponseQuota(props.row.quota) }} Respon
            </span>
          <span v-else-if="props.column.field == 'action'">
            <router-link :to="'/chat-gpt/detail?id=' + props.row.id">
              <a class="btn btn-primary text-white margin5">Detail</a>
            </router-link>
            <a
              v-on:click="duplicateChatGPT(props.row.id)"
              class="btn btn-warning text-white margin5"
            >
              Duplikat
            </a>
            <a
              v-on:click="deleteChatGPT(props.row.id)"
              class="btn btn-danger text-white margin5"
            >
              Hapus
            </a>
          </span>
          <span v-else-if="props.column.field == 'models'">
            StarSender AI
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>

  export default {
    props: ['device'],
    data() {
      return {
        table: {
          total_records: 100,
          isLoading: true,
          columns: [
            {
              label: "Nama Bot",
              field: "name",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Models",
              field: "models",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "20%",
            },
            {
              label: "Kuota Respon Tersisa",
              field: "quota",
              sortable: false,
              width: "10%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [
              {
                field: "",
                type: "",
              },
            ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteChatGPT(id) {
        if (!confirm("Yakin ingin delete chatgpt ?")) return

        try {
          let response = await this.$store.dispatch("chatgpt_delete", {id: id});
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.$toast.error("Server error");
        }
      },
      async duplicateChatGPT(id) {
        if (!confirm("Yakin ingin duplikat ChatGPT?")) return

        try {
          this.table.isLoading = true;
          await this.$store.dispatch("chatgpt_duplicate", {id: id});
          this.loadItems();
          this.$toast.success("ChatGPT berhasil diduplikat");
        } catch (err) {
          console.error(err);
          this.$toast.error(err.response?.data?.message || "Server error");
        } finally {
          this.table.isLoading = false;
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign(
          {},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({page: params.currentPage});
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({limit: params.currentPerPage});
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [
            {
              type: params.sortType,
              field: this.table.columns[params.columnIndex].field,
            },
          ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records;
          this.table.rows = response.data.data.chatgpt;

        //   for (let i = 0; i < this.table.rows.length; i++) {
        //     this.table.rows[i].count_device = JSON.parse(this.table.rows[i].device).length ?? 0
        //   }
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      getDeviceNameByID(id) {
        let device = this.device.find((d) => d.id == id);
        return device ? device.name : "";
      },
      async getFromServer(param) {
        return await this.$store.dispatch("chatgpt_list", {type: 2, ...param});
      },
      convertToRupiah(value) {
        if (typeof value !== 'number') return 'Rp 0';
        return `Rp ${value.toLocaleString('id-ID', { 
          style: 'currency', 
          currency: 'IDR', 
          minimumFractionDigits: 0, 
          maximumFractionDigits: 5 
      }).replace('Rp', '').trim()}`;      
    },
      formatResponseQuota(quota) {
        const responses = Math.floor(Number(quota || 0) / 20);
        return responses.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }

    },
  };
  </script>
  
  <style scoped>
  .margin5 {
    margin: 5px;
  }
  </style>
  